/**
 * @desc 查看平台源订单
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(shopCode: string, body: defs.walmart.AllOrdersRequest, options?: any) {
  return updateResponse(
    http(URL + `/walmart/walmartOrder/downOrder/${shopCode}`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
